/* Power-kxLee vue-print-nb */
export interface Options {
    extraHead?: string;
    extraCss?: string;
    popTitle?: string;
    endCallback?: () => void;
    id?: string;
}
export class Print {
    extraHead?: string;
    extraCss?: string;
    popTitle?: string;
    endCallback?: () => void;
    id = '';
    frameId = '';
    constructor(options: Options) {
        this.extraHead = options.extraHead;
        this.extraCss = options.extraCss;
        this.popTitle = options.popTitle;
        this.endCallback = options.endCallback;
        this.id = options.id || '';
        this.init();
    }

    init() {
        this.frameId = 'iframe_print_' + this.id;
        const PrintAreaWindow = this.getPrintWindow();
        this.write(PrintAreaWindow.doc);
        this.print(PrintAreaWindow);
        console.log(this.endCallback);
        if (this.endCallback)
            this.endCallback();
    }

    print(PAWindow) {
        const paWindow = PAWindow.win;
        const _loaded = () => {
            paWindow.focus();
            paWindow.print();
            try {
                const box = document.getElementById(this.frameId);
                box?.parentNode?.removeChild(box);
            } catch (e) {
                console.log(e);
            }
        };
        if (window.ActiveXObject) {
            paWindow.onload = _loaded();
            return false;
        }
        paWindow.onload = () => {
            console.log(paWindow);
            _loaded();
        };
    }
    write(PADocument) {
        PADocument.open();
        PADocument.write(`${this.getDocType()}<html>${this.getHead()}${this.getBody()}</html>`);
        PADocument.close();
    }
    getDocType() {
        return '<!DOCTYPE html>';
    }
    getHead() {
        let extraHead = '';
        let links = '';
        let style = '';
        if (this.extraHead) {
            this.extraHead.replace(/([^,]+)/g, (m: string) => {
                extraHead += m;
                return m;
            });
        }
        [].forEach.call(document.querySelectorAll('link'), function (item: any, i) {
            if (item?.href.indexOf('.css') >= 0) {
                links += `<link type="text/css" rel="stylesheet" href="${item?.href}" >`;
            }
        });
        const domStyle = document.styleSheets;
        if (domStyle && domStyle.length > 0) {
            for (let i = 0; i < domStyle.length; i++) {
                try {
                    if (domStyle[i].cssRules || domStyle[i].rules) {
                        const rules = domStyle[i].cssRules || domStyle[i].rules;
                        for (let b = 0; b < rules.length; b++) {
                            style += rules[b].cssText;
                        }
                    }
                } catch (e) {
                    console.log(domStyle[i].href + e);
                }
            }
        }

        if (this.extraCss) {
            this.extraCss.replace(/([^,\s]+)/g, (m) => {
                links += `<link type="text/css" rel="stylesheet" href="${m}">`;
                return m;
            });

        }

        return `<head><title>${this.popTitle}</title>${extraHead}${links}<style type="text/css">${style}</style></head>`;
    }
    getBody() {
        let id = this.id;
        id = id?.replace(new RegExp("#", "g"), '');
        const ele = document.getElementById(id!);
        const htm = ele?.outerHTML;
        return '<body>' + htm + '</body>';
    }
    getPrintWindow() {
        const f = this.Iframe();
        return {
            f: f,
            win: f.contentWindow || f,
            doc: f.doc
        };
    }
    Iframe() {
        const frameId = this.frameId;
        let iframe;
        try {
            iframe = document.createElement('iframe');
            document.body.appendChild(iframe);
            iframe.style.border = '0px';
            iframe.style.position = 'absolute';
            iframe.style.width = '0px';
            iframe.style.height = '0px';
            iframe.style.right = '0px';
            iframe.style.top = '0px';
            iframe.setAttribute('id', frameId);
            iframe.setAttribute('src', String(new Date().getTime()));
            iframe.doc = null;
            iframe.doc = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
            iframe.onload = () => {
                const win = iframe.contentWindow || iframe;
                this.print(win);
            }
        } catch (e) {
            throw new Error(e + '. iframes may not be supported in this browser.');
        }

        if (iframe.doc == null) {
            throw new Error('Cannot find document.');
        }

        return iframe;
    }
}